import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const Footer = ({ okText, cancelText, onCancel, onOk, loading }) => {
  return (
    <>
      {Boolean(cancelText) && (
        <Button onClick={onCancel} disabled={loading}>
          {cancelText}
        </Button>
      )}
      <Button
        type="primary"
        onClick={onOk}
        className={cn({ [styles.loadingBtn]: loading })}
      >
        {loading && <Icon type="loading" />}
        {okText}
      </Button>
    </>
  );
};

export default Footer;
